import CreateButton from 'components/pages/create/create-button'

export default CreateButton
